import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/home/game_arrow_white.png'


const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = {
  key: 0,
  class: "historyContainer"
}
const _hoisted_3 = {
  key: 1,
  class: "historyContainer"
}

import { ref, PropType, computed } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import CustomHeader from './customHeader.vue';
import CashBackHistoryCard from './cashBackHistoryCard.vue';
import NoData from './noData.vue';
import { convertStringToArray } from '@/utils/commonFunction';
import DayList from './dayList.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'cashbackHistoryPopup',
  props: {
    list: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    showIcon: {
        type: Boolean
    },
    title: String,
    isUseFirstRecharge: {
        type: Boolean,
        default: () => false
    }
},
  emits: ["getHistoryList", 'updateHistoryList', 'resetHistoryData'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const isShowMore = computed(() => props.showIcon)
const historyList = computed(() => props.list)

const loadingRef = ref()
const emits = __emit

const open = () => {
    show.value = true
    emits('getHistoryList')
}

const close = () => {
    show.value = false
    emits('resetHistoryData')
}

const getNextPageRewardData = () => {
    emits('updateHistoryList')
}

__expose({
    open,
    close
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      position: "right",
      style: {
        minWidth: '100%',
        minHeight: '100%',
        background: 'green',
        color: '#fff',
        overflow: 'hidden',
    }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(CustomHeader, {
            text: _ctx.$t('common.history'),
            isPopupCloseBackIcon: true,
            onClosePopup: close
          }, null, 8, ["text"]),
          (!__props.isUseFirstRecharge)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (historyList.value.length <= 0)
                  ? (_openBlock(), _createBlock(NoData, { key: 0 }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyList.value, (item, index) => {
                  return (_openBlock(), _createBlock(CashBackHistoryCard, {
                    key: index,
                    isShowDetails: false,
                    createTime: item.lossDate ?? item.createTime,
                    "day-count": item.dayCount ?? item.day,
                    title: __props.title,
                    "activity-status": item.status,
                    "given-amount": item.givenAmount ?? item.claimGiftAmount,
                    "total-amount": item.totalBetAmount ?? item.rechargeTotal ?? item.totalBetLoss,
                    "available-amount": item.remainGiftAmount ?? item.availableAmount,
                    "day-list": _unref(convertStringToArray)(item.dayRewards),
                    isShowTodayHighlight: false
                  }, null, 8, ["createTime", "day-count", "title", "activity-status", "given-amount", "total-amount", "available-amount", "day-list"]))
                }), 128)),
                (isShowMore.value)
                  ? (_openBlock(), _createBlock(_component_van_row, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_col, {
                          span: "24",
                          class: "arrowDown"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _imports_0,
                              alt: "",
                              onClick: getNextPageRewardData
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (__props.isUseFirstRecharge)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (historyList.value.length <= 0)
                  ? (_openBlock(), _createBlock(NoData, { key: 0 }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyList.value, (i, index) => {
                  return (_openBlock(), _createBlock(DayList, {
                    key: index,
                    currenyLable: true,
                    valueOne: i?.coin,
                    isShowHistory: true,
                    valueTwo: i?.turnover,
                    labelOne: 'dayList.giftAmount',
                    labelTwo: 'dayList.turnoverTimes',
                    activityStatus: i?.status,
                    time: i?.rewardDate,
                    "available-amount": i?.availableAmount,
                    "given-amount": i?.givenAmount
                  }, null, 8, ["valueOne", "valueTwo", "activityStatus", "time", "available-amount", "given-amount"]))
                }), 128)),
                (isShowMore.value)
                  ? (_openBlock(), _createBlock(_component_van_row, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_col, {
                          span: "24",
                          class: "arrowDown"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _imports_0,
                              alt: "",
                              onClick: getNextPageRewardData
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})